import { ContentStateInterface } from '../../../@types/types'
import { DispatchType } from '../../../@types/redux-types'
import { tracking } from '../../../tracking/tracking'
import { saveAndProgress } from './saveAndProgress'
import { insertionUpdateRequest } from '../../reducers/insertion/insertionFeature'
import { InitState } from '../../reducers/root/initialState'
import { getDefaultLogger } from '../../../services/logger/logger'
import { isWebView } from '../../../utils/navigation'
import { FlowName } from '../../../@types/flow-types'

export const doSave = (insertionData: ContentStateInterface, isSubmitBtnClicked: boolean) => {
  return async (dispatch: DispatchType, getState: () => InitState) => {
    dispatch(insertionUpdateRequest())
    getDefaultLogger().info('doSave', { isSubmitBtnClicked })

    let ga_cd_test_is24_cxp_de_2
    const isHomeownerApartmentRentFlow =
      getState().flowFeature.flowInformation.name === FlowName.PROPERTY_OWNER_APARTMENT_RENT
    if (isWebView() && isHomeownerApartmentRentFlow) {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('ImmoScout/ios') !== -1) {
        ga_cd_test_is24_cxp_de_2 = 'ios-insertion-flow-webview'
      } else if (userAgent.indexOf('ImmoScout/android') !== -1) {
        ga_cd_test_is24_cxp_de_2 = 'android-insertion-flow-webview'
      }
    }

    isSubmitBtnClicked &&
      tracking({
        flowInformation: getState().flowFeature.flowInformation,
        eventName: 'submit_complete_button_click',
        entryMode: getState().insertionFeature.insertionIdentification.metaInformation?.entryMode,
        moreEventParameters: {
          ga_cd_realestate_object_id: getState().insertionFeature.insertionIdentification.realEstateId?.toString(),
        },
        ga_cd_test_ppa: 'HPEP-1579-gen_ai',
        ga_cd_test_is24_cxp_de_2: ga_cd_test_is24_cxp_de_2,
      })
    insertionData.isHomeStreetHomeEnabled &&
      isSubmitBtnClicked &&
      tracking({
        eventName: 'form_submit_homelesspeople_active',
        flowInformation: getState().flowFeature.flowInformation,
        ga_cd_test_is24_cxp_de_2: ga_cd_test_is24_cxp_de_2,
      })
    await saveAndProgress(insertionData, isSubmitBtnClicked)(dispatch, getState)
  }
}
